import React, { Component } from 'react'
import Request, { API_URL, LAPI_URL, MEDIA_URL } from '../../request'
import { Button, Card, Col, Icon, Input, List, notification, Popconfirm, Row, Select, Tooltip, Upload } from 'antd'
import styles from './masterDoc.less'
import _ from 'lodash'
import moment from 'moment/moment'

const { TextArea } = Input
const Option = Select.Option

class masterDocuments extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fileDescription: '',
            fileBranches: '',
            showToStaff: '',
            files: [],
            arr: [],
            fileName: '',
        }
    }

    componentDidMount() {
        this.loadDocs()
    }

    loadDocs = () => {
        Request.fetchMasterMediaList({
            type: this.props.type,
            _id: this.props._id
        }).then(resp => {
            if (resp.success) {
                _.each(resp.arr, val => {
                    val.link = MEDIA_URL + val.url
                })

                this.setState({ arr: resp.arr });
            }
        })
    }

    handleChange = v => {
        if (v.fileList) {
            this.setState({ files: v.fileList })
        }
    }

    saveFiles = () => {
        let { types } = this.state;
        if (types && types.length > 0 && !this.state.fileName) {
            return notification.error({ message: 'Error', description: "File Name is required" })
        } else if (!this.state.fileDescription) {
            return notification.error({ message: 'Error', description: "Description is required" })
        } else if (!this.state.fileBranches) {
            return notification.error({ message: 'Error', description: "Show to branch is required" })
        } else if (!this.state.showToStaff) {
            return notification.error({ message: 'Error', description: "Show to staff is required" })
        } else if (!this.state.files) {
            return notification.error({ message: 'Error', description: "Document is required" })
        }

        let obj = {
            ...this.props,
            ...this.state
        }

        Request.saveMasterDocument(obj).then(resp => {
            if (resp.success) {
                this.loadDocs();
                this.setState({
                    fileDescription: '',
                    fileBranches: '',
                    showToStaff: '',
                    files: [],
                    file: '',
                    fileName: '',
                })
                return notification.success({
                    message: 'Success',
                    description: resp.msg
                })
            }
            if (resp.error) {
                return notification.error({ message: 'Error', description: resp.msg })
            }
        })
            .catch(err => {
                console.log(err)
            })

        // Request.saveMasterDoc(obj)
        //     .then(resp => {
        //         if (resp.success) {
        //             this.loadDocs()
        //             this.setState({
        //                 fileDescription: '',
        //                 fileBranches: '',
        //                 showToStaff: '',
        //                 files: [],
        //                 file: '',
        //                 fileName: '',
        //             })
        //             return notification.success({
        //                 message: 'Success',
        //                 description: resp.msg
        //             })
        //         }
        //         if (resp.error) {
        //             return notification.error({ message: 'Error', description: resp.msg })
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err)
        //     })
    }
    handleDelete = (val) => {
        let obj = {
            ...this.props,
            mediaId: val
        }

        Request.deleteMasterDocumentFiles(obj)
            .then(x => {
                if (x.success) {
                    this.loadDocs()
                    return notification.success({
                        message: x.msg
                    })

                } else {
                    return notification.error({ message: 'Error', description: x.msg })
                }
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })

        // Request.deleteMasterMediaFiles(obj)
        //     .then(x => {
        //         if (x.success) {
        //             this.loadDocs()
        //             return notification.success({
        //                 message: x.msg
        //             })

        //         } else {
        //             return notification.error({ message: 'Error', description: x.msg })
        //         }
        //     })
        //     .catch(err => {
        //         notification.error({
        //             message: 'Error',
        //             description: 'Some Error'
        //         })
        //     })
    }

    render() {
        let { types } = this.props;
        return (
            <React.Fragment>
                <Row>
                    <Col span={12}>
                        <Card title="Add Document">
                            {types && types.length > 0 && (
                                <div className="gutter-example">
                                    <Row gutter={16} className={styles['margin-t-md']}>
                                        <Col className="gutter-row" span={6}>
                                            <div className="gutter-box">Name</div>
                                        </Col>
                                        <Col className="gutter-row" span={18}>
                                            <div className="gutter-box">
                                                <Select
                                                    value={this.state.fileName}
                                                    required
                                                    onChange={e => {
                                                        this.setState({ fileName: e })
                                                    }}>
                                                    {
                                                        types.map((type, index) => (
                                                            <Option key={index} value={type}>{type}</Option>
                                                        ))
                                                    }
                                                </Select>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )}
                            <div className="gutter-example">
                                <Row gutter={16} className={styles['margin-t-md']}>
                                    <Col className="gutter-row" span={6}>
                                        <div className="gutter-box">Description</div>
                                    </Col>
                                    <Col className="gutter-row" span={18}>
                                        <div className="gutter-box">
                                            <TextArea
                                                rows="5"
                                                placeholder="Description"
                                                value={this.state.fileDescription}
                                                onChange={e => {
                                                    this.setState({ fileDescription: e.target.value })
                                                }}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="gutter-example">
                                <Row gutter={16} className={styles['margin-t-md']}>
                                    <Col className="gutter-row" span={6}>
                                        <div className="gutter-box">Show To Branch</div>
                                    </Col>
                                    <Col className="gutter-row" span={18}>
                                        <div className="gutter-box">
                                            <Select
                                                value={this.state.fileBranches}
                                                required
                                                onChange={e => {
                                                    this.setState({ fileBranches: e })
                                                }}>
                                                <Option key={1} value={''}>
                                                    {'Please Choose'}
                                                </Option>
                                                <Option key={1} value={'Yes'}>
                                                    {'Yes'}
                                                </Option>
                                                <Option key={2} value={'No'}>
                                                    {'No'}
                                                </Option>
                                            </Select>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="gutter-example">
                                <Row gutter={16} className={styles['margin-t-md']}>
                                    <Col className="gutter-row" span={6}>
                                        <div className="gutter-box">Show To Staff</div>
                                    </Col>
                                    <Col className="gutter-row" span={18}>
                                        <div className="gutter-box">
                                            <Select
                                                value={this.state.showToStaff}
                                                required
                                                onChange={e => {
                                                    this.setState({ showToStaff: e })
                                                }}>
                                                <Option key={1} value={''}>
                                                    {'Please Choose'}
                                                </Option>
                                                <Option key={1} value={'Yes'}>
                                                    {'Yes'}
                                                </Option>
                                                <Option key={2} value={'No'}>
                                                    {'No'}
                                                </Option>
                                            </Select>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="gutter-example">
                                <Row gutter={16} className={styles['margin-t-md']}>
                                    <Col className="gutter-row" span={6}>
                                        <div className="gutter-box">File</div>
                                    </Col>
                                    <Col className="gutter-row" span={18}>
                                        <div className="gutter-box">
                                            <Upload
                                                //  name={'file'}
                                                fileList={this.state.files}
                                                action={`${LAPI_URL}/filesUploader`}
                                                onChange={this.handleChange}>
                                                <Button>
                                                    <Icon type="upload" /> Select File
                                                </Button>
                                            </Upload>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className="gutter-example">
                                <Row gutter={16} className={styles['margin-t-md']}>
                                    <Col className="gutter-row" span={6} />
                                    <Col className="gutter-row" span={6}>
                                        <Button type="primary" onClick={this.saveFiles}>
                                            Upload Now
                                        </Button>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                    <Col span={12}>
                        <Card title="Previous Documents">
                            <List
                                className={styles['demo-loadmore-list']}
                                size="small"
                                header={<div>Total : {this.state.arr.length}</div>}
                                bordered
                                dataSource={this.state.arr}
                                renderItem={item => (

                                    <List.Item key={item.id}>
                                        <List.Item.Meta
                                            title={
                                                <a
                                                    href={item.link}
                                                    style={{
                                                        color: 'orange',
                                                        textDecorationLine: 'underline'
                                                    }}
                                                    target={'_blank'}>
                                                    {item.name}
                                                </a>
                                            }
                                            description={
                                                <div style={{ fontSize: 13 }}>
                                                    {item.fileDescription} <br></br>
                                                    <div>{item.uploadedBy && `${moment(item.uploadedBy.time).format('Do MMMM, YYYY')} [${moment(item.uploadedBy.time).format('hh:mm A')}]`}</div>
                                                    <div>{item.uploadedBy && `[${item.uploadedBy.name}]`}</div>
                                                </div>
                                            }
                                        />
                                        <div style={{ fontSize: 12 }}>
                                            Branch : {item.fileBranches}
                                        </div>
                                        <div style={{ fontSize: 12 }}>
                                            &nbsp; &nbsp; &nbsp;Staff : {item.showToStaff ? item.showToStaff : 'No'}
                                        </div>
                                        <div>
                                            <Tooltip title="Delete">
                                                <Popconfirm
                                                    title="Are you sure to delete?"
                                                    onConfirm={() => this.handleDelete(item._id)}>
                                                    <Button
                                                        style={{ marginLeft: '5px' }}
                                                        size={'small'}
                                                        shape="circle"
                                                        icon="delete" />
                                                </Popconfirm>
                                            </Tooltip>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default masterDocuments
